import { ChatMessage } from "@zoom/videosdk";
import { NavigateFunction } from "react-router-dom";
import { Action } from "redux";

export enum EUserRole {
  CANDIDATE = "hacker",
  INTERVIEWER = "interviewer",
  RECRUITER = "recruiter",
}

export enum EParticipant {
  INTERVIEWER = "INTERVIEWER",
  CANDIDATE = "CANDIDATE",
}

export interface IUserIdentity {
  name: string;
  username: string;
  role: EUserRole;
  email: string;
  user_id: string;
  is_joined: boolean;
  is_leaved: boolean;
  slug: string;
  interview_status: string;
  message?: string | null;
  isInterviewer: boolean;
  isCandidate: boolean;
}

export interface IAuthActionType {
  payload: IUserIdentity;
  type: string;
}

export interface IJoinInterviewArgs extends Action {
  payload: {
    interviewSlug: string;
    participantType: EParticipant;
    name?: string;
    email?: string;
    navigate?: NavigateFunction;
    otp?: string;
  };
}

export interface IStartInterviewArgs extends Action {
  interviewSlug: string;
  navigate: NavigateFunction;
  fromInterviewFeedback: boolean;
}

export interface IUserStatusArgs extends Action {
  interviewSlug: string;
  skipRedirect?: boolean;
}

export interface IUserAllowParticipantAction extends Action {
  payload: {
    interviewSlug: string;
    candidateSlug: string;
    candidateEmail: string;
  };
}

export interface IGetUserIdentity extends Action {
  navigate?: NavigateFunction;
}

export interface ILeaveParticipantAction extends Action {
  payload: {
    interviewSlug: string;
    navigate: NavigateFunction;
    fromEvent?: boolean;
    isAutoSubmit?: boolean;
  };
}

export interface IChatType {
  payload: ChatMessage[];
  type: string;
}

export interface ISendOTP {
  full_name: string;
  email: string;
  interview_slug: string;
}

export type TJoinInterviewPayload =
  | {
      participant_type: EParticipant;
    }
  | {
      participant_name: string;
      participant_email: string;
      otp: string;
    };

export interface IAllowUserPayload {
  candidate_slug: string;
}

export interface IAllowUserAPIResponse {
  started_at: string;
}

export interface ISendOTPAPIResponse {
  message: string;
  status: string;
  expiry: string;
}

export interface IAxiosOTPError {
  expiry: number;
  message: string;
  status: string;
}

export interface IOTP {
  otpError?: string | null;
  otpLoading?: boolean;
}

export interface ISsoAuthValidationPayload {
  redirection_uuid: string;
}

export interface ISsoAuthAPIResponse {
  interview_url: string;
  status: string;
}

export interface IAccessTokenAuthValidationAPIPayload {
  auth_token: string;
}

export interface IAccessTokenAuthValidationAPIResponse {
  redirection_url: string;
  status: string;
}
